var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeatherSmoke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.1 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #02222b;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 0.5,
    x2: 12.6,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 2.1,
    x2: 12.6,
    y2: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 3.7,
    x2: 12.6,
    y2: 3.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 5.3,
    x2: 12.6,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 6.9,
    x2: 12.6,
    y2: 6.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 8.5,
    x2: 12.6,
    y2: 8.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherSmoke);
export default __webpack_public_path__ + "static/media/icon_weather_smoke.c789b8a1e7e7c9c3b209860791d0d670.svg";
export { ForwardRef as ReactComponent };